import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { ConfirmIcon, PrismButton } from '../../components';
import { addTag, deleteTag, updateTag } from '../../actions/AdminActions';
import EditableText from '../../components/EditableText';

class AdminTagList extends Component {
  state = { newTag: '',  tagToUpdate: {} };

  addNewTag() {
    this.props.addTag(this.state.newTag);
    this.setState({ newTag: '' });
  }

  confirmTagChange(id) {
    this.props.updateTag(id, this.state.tagToUpdate.name);
    this.setState({ tagToUpdate: {} });
  }

  updateTagValue(value) {
    let tag = { ...this.state.tagToUpdate };
    tag.name = value;
    this.setState({ tagToUpdate: tag });
  }

  renderTagInput(tag) {
    let newTag = (this.state.tagToUpdate && this.state.tagToUpdate._id === tag._id) ? this.state.tagToUpdate : {};
    return (
      <div className="edit-tags-wrapper">
        <EditableText
          value={newTag && newTag.name ? newTag.name : tag.name}
          handleUpdate={() => this.confirmTagChange(tag._id)}
          onBlur={() => this.setState({ tagToUpdate: null })}
          placeholder={tag.name}
          canEdit={true}
          onChange={(value) => this.updateTagValue(value)}
        />
      </div>
    );
  }

  renderTags() {
    const { tags, deleteTag } = this.props;
    return tags.map(tag => {
      const { _id } = tag;

      return (
        <TableRow key={_id}>
          <TableCell onClick={() => this.setState({ tagToUpdate: tag }) }>
            {this.renderTagInput(tag)}
          </TableCell>
          <TableCell style={{ textAlign: 'right', width: 50 }} align="right">
            <ConfirmIcon
              tooltip="Delete Tag"
              icon="delete"
              onConfirm={() => deleteTag(_id)}
            />
          </TableCell>
        </TableRow>
      );
    });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div className="table-extra tag-adder" style={{ padding: 8, display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
          <TextField
            id="standard-full-width"
            label="Add Tag"
            className="text-field-input"
            value={this.state.newTag}
            onChange={e => this.setState({ newTag: e.target.value })}
            onKeyUp={(e) => { if (e.key && e.key === 'Enter') this.addNewTag(); }}
            autoFocus
            placeholder="Add a tag"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true
            }}
          />
          <div style={{ width: 200, paddingBottom: 10 }}>
            <PrismButton
              small
              disabled={this.state.newTag.length === 0}
              onClick={this.addNewTag.bind(this)}
            >
              Add
            </PrismButton>
          </div>
        </div>
        <div style={{ flex: 1, overflow: 'auto', marginTop: 75 }}>
          <Table className="admin-table" style={{ flex: 1 }}>
            <TableHead>
              <TableRow>
                <TableCell>Current Tags</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderTags()}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tagsStore }) => {
  const { tags } = tagsStore;
  return { tags };
};

export default connect(mapStateToProps, { addTag, deleteTag, updateTag })(AdminTagList);


// WEBPACK FOOTER //
// ./src/screens/admin/AdminTagList.js